var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#191414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C7.6 4 4 7.6 4 12C4 16.4 7.6 20 12 20C16.4 20 20 16.4 20 12C20 7.6 16.44 4 12 4ZM15.6807 15.56C15.5207 15.7993 15.2407 15.88 15 15.72C13.12 14.56 10.76 14.3193 7.95933 14.9593C7.68067 15.0407 7.44 14.84 7.36 14.6C7.28 14.3193 7.48 14.08 7.72 14C10.76 13.3193 13.4 13.6 15.48 14.88C15.76 15 15.7993 15.3193 15.6807 15.56V15.56ZM16.6407 13.36C16.44 13.64 16.08 13.76 15.7993 13.56C13.64 12.24 10.36 11.84 7.84 12.64C7.52067 12.72 7.16 12.56 7.08 12.24C7 11.92 7.16 11.5593 7.48 11.4793C10.4 10.6 14 11.0407 16.48 12.56C16.7207 12.6807 16.84 13.08 16.6407 13.36V13.36ZM16.7207 11.12C14.16 9.6 9.88 9.44 7.44 10.2007C7.04 10.32 6.64 10.08 6.52 9.72C6.4 9.31933 6.64 8.92 7 8.79933C9.84 7.95933 14.52 8.11933 17.4807 9.88C17.84 10.08 17.96 10.56 17.76 10.92C17.5607 11.2007 17.08 11.3193 16.7207 11.12V11.12Z",
    fill: "#1ED760"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.507c9b1f505feb2d87052d89d9e0fe79.svg";
export { ForwardRef as ReactComponent };